"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLocaleString;

var _PrecompiledGlobalize = _interopRequireDefault(require("../Utils/PrecompiledGlobalize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getLocaleString(value, language) {
  var globalize = (0, _PrecompiledGlobalize.default)(language);
  return globalize.dateFormatter({
    skeleton: 'MMMMdhm'
  })(new Date(value));
}